export default {
  path: '/expert-mode-inspection/:service_meter_serial_id',
  component: () => import('@/components/pages/ATServices/ExpertMode/ExpertModeInspection')
}
